import { render, staticRenderFns } from "./BPie.vue?vue&type=template&id=746e83ec&"
import script from "./BPie.vue?vue&type=script&lang=js&"
export * from "./BPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports